import React, { Component } from 'react';
import {
    Table, Icon, Divider, Button, Popconfirm,
} from 'antd';
import MachineRepairsAddContainer from '../containers/MachineRepairsAddContainer';
import constants from '../../constants';

class MachineRepairsEntryView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            repairId: null,
        };
        this.onCancel = this.onCancel.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    onCancel() {
        this.closeForm();
    }

    onDelete(id) {
        this.props.deleteLog(id);
    }


    confirm(e) {
        console.log(e);
        this.onDelete(e);
    }

    cancel(e) {
        console.log(e);
        // message.error('Click en ');
    }

    closeForm() {
        this.setState({
            openForm: false,
        });
    }

    render() {
        let columns = [
            {
                title: 'Fecha',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: text => (new Date(text).toDateString()),
            },
            {
                title: 'Costo',
                dataIndex: 'cost',
                key: 'cost',
            },
            {
                title: 'Estado',
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: 'Usuario',
                dataIndex: 'createdBy',
                key: 'createdBy',
            },
        ];

        if (this.props.extraUser.type === constants.ADMIN_ROLE
            || this.props.extraUser.type === constants.SADMIN_ROLE
            || this.props.extraUser.type === constants.SUPV_ROLE) {
            columns = columns.concat(
                {
                    title: 'Opciones',
                    key: 'action',
                    render: (text, row) => (
                        <span>
                            <Button
                                onClick={() => {
                                    this.setState({ openForm: true, repairId: row.key });
                                }}
                            >
                                <Icon type="edit" />
                            </Button>
                            <Divider type="vertical" />
                            <Popconfirm title="Estas seguro que deseas eliminar esta reparación?" onConfirm={this.confirm.bind(this, row.key)} onCancel={this.cancel} okText="Si" cancelText="No" >
                                <Button>
                                    <Icon type="delete" />
                                </Button>
                            </Popconfirm>
                        </span>
                    ),
                },
            );
        }

        const addRepairBtn = (
            <Button type="primary lg col-md-4 center-block" onClick={() => { this.setState({ openForm: true, repairId: null }); }}>
                Agregar Nueva Reparación
            </Button>
        );
        return (
            <div>
                <Table
                    columns={columns}
                    expandedRowRender={record => (
                        <p style={{ margin: 0 }}>
                            {record.details}
                        </p>
                    )}
                    dataSource={this.props.repairs}
                />
                {this.props.extraUser.type === constants.ADMIN_ROLE && addRepairBtn}
                {this.props.extraUser.type === constants.SADMIN_ROLE && addRepairBtn}
                {this.props.extraUser.type === constants.TEC_ROLE && addRepairBtn}
                {this.props.extraUser.type === constants.SUPV_ROLE && addRepairBtn}
                <MachineRepairsAddContainer
                    openForm={this.state.openForm}
                    closeForm={this.closeForm}
                    onCancel={this.onCancel}
                    repairId={this.state.repairId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                    machineId={this.props.machineId}
                />
            </div>
        );
    }
}

export default MachineRepairsEntryView;



// WEBPACK FOOTER //
// ./src/components/views/MachineRepairsListView.js